<template>
  <div class="etapa-formulario">
    <div class="etapa-formulario__grid">
      <slot />
    </div>
  </div>
</template>

<script lang="js">
/**
 * Estrutura base de formulário das etapas do cadastro de novo relato.
 *
 * Renderiza o grid de campos via slot. O card que envolve a etapa
 * (com as abas no cabeçalho e os botões de ação no footer) é montado
 * pelo container. O conteúdo (campos) é passado via slot; cada campo
 * deve estar envolto em um `<div class="etapa-formulario__campo">`
 * (com modificadores `--md-*` e `--xl-*` para ocupar colunas do grid).
 */
export default {
  name: "EtapaFormulario"
};
</script>

<style lang="scss">
@import '../../styles/_main';
@import '../../styles/layout/_etapa-formulario';
</style>


